export function superModal(options, callbackObject) {
    var $ = jQuery;

    //Resetting
    $('#super-modal .btn-close').addClass("d-none");
    $(document).off('click', '#super-modal .btn-confirm');

    //Options
    let title = options.title || 'Cím';
    let body = options.body || '<div class="text-center my-5"><i class="fas fa-spinner loading"></i></div>';
    let headColor = options.headColor || "#fff";
    let size = options.size || "";

    let checkbox = options.checkbox || false;
    let checkboxText = options.checkboxText || false;
    let field = options.field || false;
    
    let select = options.select || false;
    let selectValues = options.selectValues || [];

    let confirm = options.confirm || false;
    let noText = options.noText || 'Mégse';
    let yesText = options.yesText || 'OK';
    let callback = callbackObject || {"run":function(){$('#super-modal').modal('hide')}};
    let noButtons = options.hideButtons || false;
    let fixCallback = options.fixCallback || false;

    $('#super-modal .modal-title').text(title);
    if(body != '')
        $('#super-modal .modal-body').html(body);
    $('#super-modal .btn-close').html(noText);
    $('#super-modal .btn-confirm').html(yesText);
    $('#super-modal .modal-header').css("background", headColor);
    $('#super-modal').removeClass('content-modal');
    $('#super-modal').removeClass('course-conf-modal');

    $("#super-modal .modal-dialog").addClass(size);

    if(noButtons){
        $('#super-modal .btn-confirm').addClass('d-none');
        $('#super-modal .btn-close').addClass('d-none');
    }else{
        $('#super-modal .btn-confirm').removeClass('d-none');
    }

    if(confirm){
        $('#super-modal .btn-close').removeClass("d-none");
    } 
    if(checkbox){
        $('#super-modal .modal-body').append(`<div class="pt-3"><input type="checkbox" name="modal-checkbox-field" class="modal-checkbox-field" value="true"> ${checkboxText}<br></div>`)
    }
    if(field){
        $('#super-modal .modal-body').append('<div class="pt-3"><input class="w-100 modal-input-field" type="number" name="modal-input-field"></div>')
    }
    if(select){
        $('#super-modal .modal-body').append('<div class="pt-3"><select class="modal-select-field" name="cars" id="cars"></select></div>');
        $.each(selectValues, function (i, item) {
            $('#super-modal .modal-body .modal-select-field').append($('<option>', { 
                value: item.value,
                text : item.text 
            }));
        });
    }
    if(fixCallback)
        $(document).on('click','#super-modal .btn-confirm', function(event){
        if(field)
            callback.modalField = $('#super-modal .modal-input-field').val();
        if(checkbox)
            callback.modalCheckbox = $('#super-modal .modal-checkbox-field').prop('checked');
        if(select)
            callback.modalSelect = $('#super-modal .modal-select-field').val();
        return callback.run(callback);                
        });
    else
        $(document).one('click','#super-modal .btn-confirm', function(event){
            if(field)
                callback.modalField = $('#super-modal .modal-input-field').val();
            if(checkbox)
                callback.modalCheckbox = $('#super-modal .modal-checkbox-field').prop('checked');
            if(select)
                callback.modalSelect = $('#super-modal .modal-select-field').val();
            return callback.run(callback);                
        });

    $('#super-modal').modal('show');
}

export function successModal(body, redirect = false, title = "Siker") {
    $ = jQuery;
    let options = {
        'title': title,
        'body': body,
        'confirm': false,
    }; 
    let callback = {
        'run': function(params){
            if(params.redirect)
                window.location = params.redirect
            $('#super-modal').modal('hide');
        },
        'redirect': redirect,
    }
    superModal(options, callback);
}
export function errorModal(body) {
    $('.modal').modal('hide');
    $ = jQuery;
    let options = {
        'title': "Hiba",
        'body': body,
        'confirm': false,
    }; 
    let callback = {
        'run': function(params){
            $('#super-modal').modal('hide');
        },
    }
    superModal(options, callback);
}
export function confirmModal(title, body, callbackObject) {
    let options = {
        'title': title,
        'body': body,
        'confirm':true
    }; 
    let callback = callbackObject
    superModal(options, callback);
}
//FORM MODAL WITH SUBMIT BUTTON
export function formModal(title, getUrl, postUrl, data) {
    ajaxCall(getUrl, 'POST', data);
    let options = {
        'title': title,
        'body': '',
        'yesText': 'Mentés',
        'size': 'modal-lg',
        'confirm': true,
        'fixCallback': true
    }; 
    let callback = {
        'run': function(params){
            $('#super-modal .btn-confirm').addClass("disabled");
            $('#super-modal .btn-confirm').addClass("load");
            $.post({
                url: params.url,
                contentType: false,
                processData: false,
                data: new FormData($('#super-modal form')[0]),
                success: function(response){
                    let data = JSON.parse(response);
                    if($('#applicationForm').length)
                        setTimeout(function() {successModal(data.message)}, 500);
                    else
                        setTimeout(function() {successModal(data.message, data.url);}, 500);
                    
                    if($('select[name=kutya]').length){
                        let selectElement = $('select[name=kutya]')[0];
                        selectElement.add(new Option(data.name, data.id));
                        $('select[name=kutya]').selectmenu('refresh');
                        $('.have-dog').removeClass('d-none');
                        $('.none-dog').addClass('d-none');
                        $('#super-modal').modal('hide');
                    }
                },
                complete: function(){
                    $('#super-modal .btn-confirm').removeClass("disabled");
                    $('#super-modal .btn-confirm').removeClass("load");
                    $('#super-modal select').selectmenu();
                },
                error: function(xhr, textStatus) {
                    let data = JSON.parse(xhr.responseText);
                    //Validátor
                    if(xhr.status == 400){
                        if(data.action == "error-modal")
                            setTimeout(function() {errorModal(data.message);}, 500)
                        else
                        Object.keys(data).forEach(function (key) {
                            let field = $(`input[name='${key}']`);
                            field.siblings('small').remove();
                            field.addClass('validation-error');
                            field.parent().append(`<small>${data[key]}</small>`);
                        });
                    }     
                }          
            });
        },
        'url': postUrl,
    }
    superModal(options, callback);
}
//FORM MODAL WITH NO SUBMIT BUTTON
export function infoModal(title, url, data) {
    ajaxCall(url, 'POST', data);
    let options = {
        'title': title,
        'body': '',
        'size': 'modal-lg',
    }; 
    let callback = {
        'run': function(params){
            $('#super-modal').modal('hide')
        },
    }
    superModal(options, callback);
}

export function contentModal(title, body){
    var $ = jQuery;
    let options = {
        'title': title,
        'body': body,
        'size': 'modal-lg',
        'hideButtons': true
    };
    superModal(options);
    $('#super-modal').addClass('content-modal');
}

//COURSE CONFIRM BEFORE SUBMIT
export function courseConfirmModal(){
    let formData = new FormData(document.getElementById("applicationForm"));
    let course_id = $('input[name="course_id"]').val();
    formData.append('course_id', course_id);
    let dog_id = $('select[name="kutya"]').val();
    if(dog_id)
        formData.append('dog_id', dog_id);
    ajaxCall("/course-confirm-modal", 'POST', formData);  
    let options = {
        'title': "Kérjük ellenőrizze adatai helyességét!",
        'body': '',
        'hideButtons': true,
    }
    superModal(options);
    $('#super-modal').addClass('course-conf-modal');
}